import { unitTranslation } from "@/common/constants/unitStrategies.contants";
import { strategyToOptions } from "@/common/utils/strategyToOptions";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";
import DashboardFilterBadge from "../DashboardFilterBadge";

const unitForConsumptionOptions = strategyToOptions(unitTranslation);

const DashboardFilterEquipmentCategoryUnitForConsumptionBadge = ({ filters, setFilters }: DashboardFilterProps) => {
  return (
    <DashboardFilterBadge
      filterKey={DashboardFilters.EquipmentCategoryUnitForConsumption}
      options={unitForConsumptionOptions}
      filters={filters}
      setFilters={setFilters}
    />
  );
}

export default DashboardFilterEquipmentCategoryUnitForConsumptionBadge;
